import { createSlice, createSelector } from '@reduxjs/toolkit';
import { EType } from '../type';

const defaultState = {
  loading: true,
  editting: {},
};
//TODO:Filter单选和多选的问题
const inventoryListSlice = createSlice({
  name: 'inventoryList',
  initialState: defaultState,
  reducers: {
    setEdittingMap: (state, action) => {
      const { inventoryUuid, obj } = action.payload;
      const target = state.editting[inventoryUuid];
      if (target) {
        state.editting[inventoryUuid] = { ...target, ...obj };
      } else {
        state.editting[inventoryUuid] = { type: EType.Add, ...obj };
      }
    },
    clearEditingMap: (state) => {
      state.editting = {};
    },
  },
});
export const getEditingValue = (inventoryUuid) => {
  return createSelector(
    [(state: any) => state.inventoryList.editting],
    (editting = {}) => {
      return editting[inventoryUuid] || {};
    },
  );
};
export const getFilterValue = () => {
  return createSelector(
    (state: any) => state.inventoryList.sort,
    (state) => state.inventoryList.searchList,
    (state) => state.inventoryList.filter,
    (sort, searchList, filter) => {
      return { sort, searchList, filter };
    },
  );
};
export const { setEdittingMap, clearEditingMap } = inventoryListSlice.actions;

export default inventoryListSlice.reducer;
